import { memo } from 'react';

import { ConfigProvider, Select } from 'antd';

function CombinatorSelector({ options, value, handleOnChange }) {
  return (
    <ConfigProvider
      theme={{
        components: {
          Select: {
            activeBorderColor: '#51ae32',
            selectorBg: '#e5eddf',
            optionFontSize: 12,
            optionSelectedBg: '#e5eddf',
            hoverBorderColor: '#e5eddf'
          }
        }
      }}>
      <Select className="combinator-select" options={options} value={value} onChange={handleOnChange} />
    </ConfigProvider>
  );
}

export default memo(CombinatorSelector);
